import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as searchJobsService from "../../services/searchJobs.service";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDateWithMonth, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder} from "rsuite";



const ViewSearchedJobs = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Searched Jobs"),
      url: "/admin/jobs-management/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    const formData = new FormData()
    formData.append("_id",params?._id)
    searchJobsService
      .Details(formData)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


 const writtenFunction = (skill_preferences) => {

  const formattedSkills = skill_preferences.map((skill) => {
    return skill
      .split('_')  
      .map((word) => (word)) 
      .join(' '); 
  });
  return capitalizeFirstLetter(formattedSkills.join(', ')); 
};


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  VIEW Searched Job
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Category")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.categoryId?.title
                              ? capitalizeFirstLetter(showdefault?.categoryId?.title)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th className="text-capitalize">{t("Subcategory")}</th>
                          <td>
                            {showdefault && showdefault?.subcategoryId?.title
                              ? (showdefault?.subcategoryId?.title.replace('Babysitter','Baby Sitter'))
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("User Name")}</th>
                          <td>
                            {showdefault && showdefault?.userData?.name
                              ? capitalizeFirstLetter(showdefault?.userData?.name)
                              : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("User Email")}</th>
                            <td>
                            {showdefault && showdefault?.userData?.email
                              ? (showdefault?.userData?.email)
                              : "N/A"}
                          </td>
                        </tr> */}

                        {/* <tr>
                          <th>{t("Gender")}</th>
                          <td>
                            {showdefault && showdefault.gender
                              ? capitalizeFirstLetter(showdefault.gender)
                              : "N/A"}
                          </td>
                        </tr> */}
                        <tr>
                          {/* <th>{t("Experience")}</th>
                          <td>
                            {showdefault && showdefault.experience + " " + "year"
                              ? (showdefault.experience + " " + "year")
                              : "N/A"}
                          </td> */}




                        </tr>
                          <tr>
                          <th>{t("lable_zip_code")}</th>
                          <td>
                            {showdefault && showdefault
                              ? (showdefault.zip_code)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Created Date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? (showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>

                         <tr>
                          <th>{t("First Aid Trained")}</th>
                          <td>
                              {
                              showdefault && 
                              showdefault.first_aid_trained===true 
                              ? "Yes" 
                              : "No"
                              }
                          </td>
                        </tr>
                                
                         <tr>
                          <th>{t("Skill Preferences")}</th>
                          <td>
                              {
                              showdefault && showdefault.skill_preferences ? 
                              writtenFunction(showdefault.skill_preferences) 
                              :
                              ('N/A')
                              }
                          </td>
                        </tr>
                                

                          <tr>
                          <th>{t("Cpr Trained")}</th>
                          <td>
                            {/* {showdefault && showdefault.cpr_trained
                              ? (showdefault.cpr_trained)
                              : "N/A"} */}

                              {
                              showdefault && 
                              showdefault.cpr_trained===true 
                              ? "Yes" 
                              : "No"
                              }
                          </td>
                        </tr>
                                           

                          <tr>
                          <th>{t("Primary Language")}</th>
                          <td>
                             {showdefault.primary_language
                             ? capitalizeFirstLetter(showdefault.primary_language)
                             : ("N/A")
                             }
                          </td>
                        </tr>                        


                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
               <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>


            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/jobs-management/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSearchedJobs;
